import { render, staticRenderFns } from "./Nvai.vue?vue&type=template&id=33370d2e&scoped=true"
import script from "./Nvai.vue?vue&type=script&lang=js"
export * from "./Nvai.vue?vue&type=script&lang=js"
import style0 from "./Nvai.vue?vue&type=style&index=0&id=33370d2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33370d2e",
  null
  
)

export default component.exports